import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfirmTfaDisableDto } from '../dtos/tfa/tfa.dto';
import { ConfirmTfaEnableDto } from '../dtos/tfa/tfa.dto';
import { BaseService } from './base.service';
import { Twofa } from '../services/constants/map-forest'
import { AuthKeycloakService } from './auth-keycloak.service';

@Injectable()
export class TfaManageService extends BaseService {
  constructor(
    private http: HttpClient, 
    protected authKeycloakService: AuthKeycloakService
  ) {
    super(authKeycloakService);

  }

  enable2fa(): Observable<any> {
    return this.http
      .post(`${Twofa.TWOFA}${'/enable/'}`, null, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  enable2faconfirm(dto: ConfirmTfaEnableDto): Observable<any> {
  // pega o token de forma síncrona
  const user_token = this.authKeycloakService.getToken();

  const defined = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user_token?.toString()}`,
    }),
  };

  return this.http
    .post(`${Twofa.TWOFA}/enable/confirm/${dto.code}/`, null, defined)
    .pipe(map(this.extractData), catchError(this.serviceError));
}

  disable2fa(): Observable<any> {
    return this.http
      .post(`${Twofa.TWOFA}${'/disable'}/`, null, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  disable2faconfirm(dto: ConfirmTfaDisableDto): Observable<any> {
  // pega o token de forma síncrona
  const user_token = this.authKeycloakService.getToken();

  const defined = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user_token?.toString()}`,
    }),
  };

  return this.http
    .post(`${Twofa.TWOFA}/disable/confirm/${dto.code}/`, null, defined)
    .pipe(map(this.extractData), catchError(this.serviceError));
}
}